export class Installation {
    s_ins: number;
    user_name: string;
    ins_no: string;
    ins_name: string;
    s_cont: number;
    cix: number;
    pix: number;
    s_pc: number;
    selected: number;
    ins_lat: string;
    ins_lon: string;
    geoAround: boolean;
    distance: number;
    alarmNotificationIn: boolean;
    alarmNotificationOut: boolean;
    cust_support_phone: string;
    settings: string;
    alias: string;
    ctr_no: string;
    street1: string;
    displayTitle: string;
    timer_flg: number;
    timer_count: number;
    timer_set: number;
    clientCategory: string;
    tariffName: string;
    tariffCategory: string;
    userid: string;
    
    constructor() {
        this.geoAround = false;
        this.distance = 0;
        this.alarmNotificationIn = false;
        this.alarmNotificationOut = false;
    }

    setInstallation(s_ins: number, user_name: string, ins_no: string, ins_name: string, s_cont: number, cix: number,
        pix: number, s_pc: number, selected: number, ins_lat: string, ins_lon: string, cust_support_phone: string,
        settings: string, alias: string, ctr_no: string, street1: string, displayTitle: string, timer_flg: number, 
        timer_count: number, timer_set: number, clientCategory: string, tariffName: string, tariffCategory: string, userid: string,
        geoAround = false, distance = 0, alarmNotificationIn = false, alarmNotificationOut = false){
            this.s_ins = s_ins;
            this.user_name = user_name;
            this.ins_no = ins_no;
            this.ins_name = ins_name;
            this.s_cont = s_cont;
            this.cix = cix;
            this.pix = pix;
            this.s_pc = s_pc;
            this.selected = selected;
            this.ins_lat = ins_lat;
            this.ins_lon = ins_lon;
            this.cust_support_phone = cust_support_phone;
	        this.settings = settings;
            this.geoAround = geoAround;
            this.distance = distance;
            this.alarmNotificationIn = alarmNotificationIn;
            this.alarmNotificationOut = alarmNotificationOut;
            this.alias =  alias;
            this.ctr_no =  ctr_no;
            this.street1 =  street1;
            this.displayTitle = displayTitle;
            this.timer_flg = timer_flg;
            this.timer_count = timer_count;
            this.timer_set = timer_set;
            this.clientCategory= clientCategory
            this.tariffName = tariffName;
            this.tariffCategory = tariffCategory;
            this.userid = userid;
    }

    setGeoAround(geoAround: boolean, distance: number){
        this.geoAround = geoAround;
        this.distance = distance;
    }
}